import { render, staticRenderFns } from "./PDisplayProductImages.vue?vue&type=template&id=08113c8c"
import script from "./PDisplayProductImages.vue?vue&type=script&lang=js"
export * from "./PDisplayProductImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports